module.exports = "<h1> User Profiles </h1>\n<div class=\"online-users\">\n  <ul>\n    <h3> Which user profile do you want to see? </h3>\n    <li *ngFor=\"let user of onlineUsers | async\" (click)=\"inquireUser(user.$key)\">\n      <strong>{{user.username}}: </strong>{{user.in_game}}\n    </li>\n  </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/user-profile/user-profile.component.html
// module id = ./src/app/user-profile/user-profile.component.html
// module chunks = 1